import { Box, makeStyles } from '@material-ui/core';
import { ReactNode } from 'react';
import AppBar from '../app-bar/container';
import AppMaintenance from '../app-maintenance/container';
import AutomaticLogout from '../automatic-logout/container';
import ContactIDRouteAction from '../contact-id-route-action/container';
import portalLayoutStyles from '../app-secure/styles';

interface PortalLayoutProps {
  appBar?: boolean;
  automaticLogout?: boolean;
  children: ReactNode;
  contactIdRoute?: string;
}

const usePortalLayoutStyles = makeStyles(portalLayoutStyles);

export function PortalLayout({
  appBar = true,
  automaticLogout = false,
  children,
  contactIdRoute,
}: PortalLayoutProps) {
  const classes = usePortalLayoutStyles();

  return (
    <Box className={classes.appContainer}>
      {automaticLogout && <AutomaticLogout />}

      {appBar && <AppBar />}

      {children}

      <AppMaintenance />

      {contactIdRoute && <ContactIDRouteAction />}
    </Box>
  );
}

interface PublicLayoutProps {
  children: ReactNode;
}

export function PublicLayout({ children }: PublicLayoutProps) {}
